import React, { useRef, useEffect } from 'react';
import { animate } from 'animejs';
import { useLanguage } from '../context/LanguageContext';
import Stats from './Stats';
import './WhyUs.css';

const pointIds = ['seguridad', 'puntualidad', 'confiabilidad', 'calidad', 'transparencia'];

const pointIcons = {
  seguridad: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  puntualidad: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  confiabilidad: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M12 2a10 10 0 0110 10c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  calidad: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M5 17h14v-4H5v4zM5 9h14V5H5v4z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  transparencia: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M9 14l6-6M15 14H9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

function WhyUs() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        const items = section.querySelectorAll('.why-item');
        items.forEach((el, i) => {
          animate(el, {
            opacity: [0, 1],
            x: [24, 0],
            duration: 500,
            delay: i * 90,
            ease: 'outExpo',
          });
        });
        observer.disconnect();
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="why-us">
      <h2 id="why-title" className="section-title">{t('commitment.title')}</h2>
      <div className="why-grid">
        {pointIds.map((id) => (
          <article key={id} className="why-item">
            <span className="why-icon" aria-hidden="true">{pointIcons[id]}</span>
            <div>
              <h3 className="why-item-title">{t(`commitment.${id}.title`)}</h3>
              <p className="why-item-text">{t(`commitment.${id}.text`)}</p>
            </div>
          </article>
        ))}
      </div>
      <Stats />
    </div>
  );
}

export default WhyUs;
